import Avatar from '../avatar/component-lib.esm.js';

//
var script = {
  name: 'ListItemAvatar',
  components: {
    Avatar
  },
  props: {
    size: {
      type: [Number, String],
      default: 40
    }
  }
};
export { script as default };